import { getPlural } from 'lib/string/pluralize'
import type { IntlShape } from 'react-intl'

export default (partnership: App.Partnership, intl: IntlShape): string => {
  return partnership.rewardEarn === 1 ?
      intl.formatMessage(
        {
          id: '-e-AAXcTwhhpjdngCMgQ',
          defaultMessage: '{rewardEarn} {rewardProgramName} {bonusUnitSingular} per {rewardPer}',
          description: 'Partnership reward message showing one bonus unit earned per spending amount',
        },
        {
          rewardEarn: partnership.rewardEarn,
          rewardProgramName: partnership.rewardProgramName,
          bonusUnitSingular: partnership.bonusUnit,
          rewardPer: partnership.rewardPer,
        },
      ) :
      intl.formatMessage(
        {
          id: 'yaKL0QknOFEIsGLAGiqY',
          defaultMessage: '{rewardEarn} {rewardProgramName} {bonusUnitPlural} per {rewardPer}',
          description: 'Partnership reward message showing multiple bonus units earned per spending amount',
        },
        {
          rewardEarn: partnership.rewardEarn,
          rewardProgramName: partnership.rewardProgramName,
          bonusUnitPlural: getPlural(partnership.bonusUnit),
          rewardPer: partnership.rewardPer,
        },
      )
}
